export default {
  shape:
    '<path d="M10.6074 0.818848L1.60742 9.81885" stroke="#979797" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.6074 9.81885L1.60742 0.818848" stroke="#979797" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  viewBox: [0, 0, 12, 11],
};
